import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import VehicleModelIndex from "../../../../components/SidetabPages/Catalog/VehicleModel/VehicleModelIndex";

const VehicleModels = () => {
  return (
    <>
      <AnnouncementBar />
      <VehicleModelIndex />
    </>
  );
};
export default VehicleModels;
